import React, { useEffect, useState } from 'react';
import { useFormContext } from "react-hook-form";
import { IEmailConta } from "../../../../../../Interfaces/Geral/GestaoDeCadastro/Emailconta/EmailContaInterface";
import { IConfigRegua } from "../../../../../../Interfaces/Automacao/Regua/ConfiguracaoDeRegua/ConfiguracaoDeReguaInterfaces";

interface IEmailProps {
    configRegua?: IConfigRegua;
    lstEmails: Array<IEmailConta>;
}

interface IEmailFormData {
    ID_CONTA_EMAIL_ENVIO: number;
    DS_EMAIL_COPIA_OCULTA: string;
    DS_EMAIL_RECEPTIVO_TESTE: string;
    NR_MAX_EMAIL: number;
}

export default function Email(props: IEmailProps) {
  const { register, formState } = useFormContext<IEmailFormData>();

  const [listEmails, setListEmails] = useState<IEmailConta[]>([]);
  const [emailEnvio, setEmailEnvio] = useState<number>(0);

  useEffect(() => {
    if (props.lstEmails) {
      setListEmails(props.lstEmails);
    }
  }, [props.lstEmails]);

  useEffect(() => {
    setEmailEnvio(props.configRegua?.ID_CONTA_EMAIL_ENVIO || 0);
  }, [props.configRegua?.ID_CONTA_EMAIL_ENVIO]);

  return (
    <div className="row">
      <div className="form-group col-12 col-lg-6">
        <label>Email Conta</label>
        {listEmails.length > 0 && ( // Renderizar select apenas quando listEmails estiver carregado
          <>
            <select
              className={`form-control placeholder-dark-75 ${
                formState.errors.ID_CONTA_EMAIL_ENVIO && 'is-invalid'
              }`}
              name="ID_CONTA_EMAIL_ENVIO"
              ref={register()}
              defaultValue={emailEnvio}
            >
              <option value=""></option>
              {listEmails.map((email) => (
                <option
                  value={email.ID_EMAIL_CONTA}
                  key={email.ID_EMAIL_CONTA}
                >
                  {email.DS_REMETENTE}
                </option>
              ))}
            </select>
            <div className="invalid-feedback">
              {formState.errors.ID_CONTA_EMAIL_ENVIO
                ? formState.errors.ID_CONTA_EMAIL_ENVIO.message
                : ""}
            </div>
          </>
        )}
      </div>
            <div className="form-group col-12 col-lg-6">
                <label>Email de Teste</label>
                <input
                    className={`form-control placeholder-dark-75 ${
                        formState.errors.DS_EMAIL_RECEPTIVO_TESTE &&
                        "is-invalid"
                    }`}
                    type="text"
                    defaultValue={
                        props.configRegua?.DS_EMAIL_RECEPTIVO_TESTE || ""
                    }
                    name="DS_EMAIL_RECEPTIVO_TESTE"
                    ref={register()}
                />
                <div className="invalid-feedback">
                    {formState.errors.DS_EMAIL_RECEPTIVO_TESTE
                        ? formState.errors.DS_EMAIL_RECEPTIVO_TESTE.message
                        : ""}
                </div>
            </div>
            <div className="form-group col-12 col-lg-6">
                <label>Email Cópia Oculta</label>
                <input
                    className={`form-control placeholder-dark-75 ${
                        formState.errors.DS_EMAIL_COPIA_OCULTA && "is-invalid"
                    }`}
                    type="email"
                    defaultValue={
                        props.configRegua?.DS_EMAIL_COPIA_OCULTA || ""
                    }
                    name="DS_EMAIL_COPIA_OCULTA"
                    ref={register()}
                />
                <div className="invalid-feedback">
                    {formState.errors.DS_EMAIL_COPIA_OCULTA
                        ? formState.errors.DS_EMAIL_COPIA_OCULTA.message
                        : ""}
                </div>
            </div>
            <div className="form-group col-12 col-lg-6">
                <label>Número máximo de e-mails</label>
                <input
                    className={`form-control placeholder-dark-75 ${
                        formState.errors.NR_MAX_EMAIL && "is-invalid"
                    }`}
                    type="number"
                    defaultValue={props.configRegua?.NR_MAX_EMAIL}
                    name="NR_MAX_EMAIL"
                    min={0}
                    ref={register({
                        min: {
                            value: 0,
                            message:
                                "Insira um número máximo de e-mails válido",
                        },
                    })}
                />
                <div className="invalid-feedback">
                    {formState.errors.NR_MAX_EMAIL
                        ? formState.errors.NR_MAX_EMAIL.message
                        : ""}
                </div>
            </div>
        </div>
    );
}
